import { addMonths, parseISO, startOfMonth } from 'date-fns';
import { lastWeeks, localDate } from '@/lib/dates';
import type { ViewRange } from '@/lib/view-range';

/** How long one bucket of a statistics series is. */
export const STATS_GROUPINGS = ['week', 'month'] as const;
export type StatsGrouping = (typeof STATS_GROUPINGS)[number];

/** The first view of the statistics, which entering the page prefetches. */
export const DEFAULT_STATS_RANGE: ViewRange = '3m';
export const DEFAULT_STATS_GROUPING: StatsGrouping = 'week';

// Whole buckets, the current one last: so every bucket but the last is
// complete, and the longest range stays inside the API's 366 days.
const BUCKETS: Record<StatsGrouping, Record<ViewRange, number>> = {
  week: { '1m': 5, '3m': 13, '1y': 52 },
  month: { '1m': 2, '3m': 4, '1y': 12 },
};

/**
 * A range as the statistics read takes it: from the first day of its oldest
 * bucket to the day after its newest, which is the bucket `today` is in.
 */
export function statsRange(
  range: ViewRange,
  grouping: StatsGrouping,
  today: string,
) {
  const buckets = BUCKETS[grouping][range];
  if (grouping === 'week') return lastWeeks(today, buckets);
  const thisMonth = startOfMonth(parseISO(today));
  return {
    fromDate: localDate(addMonths(thisMonth, 1 - buckets)),
    toDate: localDate(addMonths(thisMonth, 1)),
  };
}
